import $ from 'jquery';
import queue from '../../utils/queue';

const ICONS = {
        warn: 'msgIconWarn',
        confirm: 'msgIconConfirm'
    },
    WAIT = 5000,
    STORAGE_KEY = 'spMessages',
    messenger = {
        _build: function(msg) {
            var type = msg.type;
            return $(
                '<div class="msgBody msgrBody">' +
                    '<a href="#" class="msgIconClose"></a>' +
                    '<div class="msgContent">' +
                    (type && type in ICONS ? '<div class="' + ICONS[type] + '"></div>' : '') +
                    msg.content +
                    '</div>' +
                    '</div>'
            ).appendTo('body');
        },
        _closeActiveMessage: function(callback) {
            messenger._$activeMessage.slideUp(typeof callback === 'function' ? callback : noop);
        },
        _closeRemoveResetAndReprocess: function() {
            messenger._closeActiveMessage(function() {
                messenger._resetTimer();
                messenger._$activeMessage.remove();
                messenger._isOpen = false;
                messenger._process();
            });
        },
        _getMessagesInStorage: function() {
            return hasLocalStorage() ? JSON.parse(localStorage.getItem(STORAGE_KEY)) : null;
        },
        _hasMessagesInStorage: function() {
            var messages = messenger._getMessagesInStorage();

            return !!messages && messages.length > 0;
        },
        _handleMessagesInStorage: function() {
            if (messenger._hasMessagesInStorage()) {
                $.each(messenger._getMessagesInStorage(), function(index, message) {
                    messenger.add(message);
                });

                if (hasLocalStorage()) {
                    localStorage.removeItem(STORAGE_KEY);
                }
            }
        },
        _openActiveMessage: function(callback) {
            messenger._$activeMessage.slideDown(typeof callback === 'function' ? callback : noop);
        },
        _process: function() {
            if (messenger._queue.hasNext()) {
                messenger._isOpen = true;
                messenger._$activeMessage = messenger._build(messenger._queue.next());
                messenger._setupCloseClickEvent();
                messenger._openActiveMessage(function() {
                    messenger._timer = setTimeout(messenger._closeRemoveResetAndReprocess, WAIT);
                });
            }
        },
        _resetTimer: function() {
            if (messenger._timer) {
                clearTimeout(messenger._timer);
                messenger._timer = null;
            }
        },
        _setMessageInStorage: function(message) {
            var messages = messenger._getMessagesInStorage() || [];

            messages.push(message);

            if (hasLocalStorage()) {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(messages));
            }
        },
        _setupCloseClickEvent: function() {
            messenger._$activeMessage.on('click', messenger._closeRemoveResetAndReprocess);
        },
        add: function(messageDetails) {
            if (messageDetails && messageDetails.type && messageDetails.content) {
                if (!messageDetails.immediate) {
                    messageDetails.immediate = true;
                    messenger._setMessageInStorage(messageDetails);
                } else {
                    messenger._queue.add(messageDetails);

                    if (!messenger._isOpen) {
                        messenger._process();
                    }
                }
            }
        },
        confirm: function(message, runOnNextPage) {
            messenger.add({type: 'confirm', content: message, immediate: !runOnNextPage});
        },
        warn: function(message, runOnNextPage) {
            messenger.add({type: 'warn', content: message, immediate: !runOnNextPage});
        },
        init: function() {
            messenger._queue = queue();
            messenger._timer = null;
            messenger._isOpen = false;

            if (messenger._hasMessagesInStorage()) {
                $(window).on('load', messenger._handleMessagesInStorage);
            }

            return messenger;
        }
    };

// eslint-disable-next-line no-empty-function
function noop() {}

function hasLocalStorage() {
    var test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
        // eslint-disable-next-line no-unused-vars
    } catch (e) {
        return false;
    }
}

export default messenger;
